export const _translations = {
	legacy: false,
	locale: 'de',
	messages: {
		en: {
			hubs: {
				common: {
					dash: '—',
				},
				header: {
					title: 'Hubs',
					totalModules: '{count} modules',
					searchPlaceholder: 'Search hubs',
					searchAria: 'Search hubs',
					sortAria: 'Sort hubs',
				},
				sort: {
					lastLog_desc: 'Last Call (newest)',
					lastLog_asc: 'Last Call (oldest)',
					name_asc: 'Hub Name (A→Z)',
					name_desc: 'Hub Name (Z→A)',
					projectName_asc: 'Project (A→Z)',
					projectName_desc: 'Project (Z→A)',
					moduleCount_desc: 'Module Count (high→low)',
					moduleCount_asc: 'Module Count (low→high)',
					state_asc: 'State (A→Z)',
				},
				list: {
					noMatch: 'No hubs match “{search}”.',
					noData: 'No hubs available yet.',
					modulesLabel: '{count} modules',
					graphsLabel: '{count} graphs',
					settings: 'Settings',
					project: 'Project',
					location: 'Location',
					lastCall: 'Last Call',
					ipAddress: 'IP Address',
					state: 'State',
					timezone: 'Timezone',
					modulesTitle: 'Modules',
					graphsTitle: 'Graphs',
				},
				modulesTable: {
					headers: {
						module: 'Module',
						serial: 'Serial',
						state: 'State',
						lastLog: 'Last Log',
						alertInterval: 'Alert Interval',
						visibility: 'Visibility',
						id: 'Id',
						actions: 'Actions',
					},
					alertIntervalValue: '{value} min',
					hidden: 'Hidden',
					visible: 'Visible',
					recalc: 'Recalculate',
					noModules: 'No modules connected.',
					toast: {
						recalcFailed: 'Recalculation failed.',
						recalcRequested: 'Recalculation requested.',
						recalcError: 'Error recalculating module.',
						alertIntervalUpdated: 'Alert interval updated.',
						alertIntervalFailed: 'Failed to update alert interval.',
						visibilityUpdated: 'Visibility updated.',
						visibilityFailed: 'Could not update visibility.',
						stateUpdated: 'State updated.',
						stateFailed: 'Could not update state.',
					},
				},
				graphsTable: {
					headers: {
						graph: 'Graph',
						state: 'State',
						lastLog: 'Last Log',
						linkedModule: 'Linked Module',
						id: 'Id',
					},
					empty: 'No graphs for this hub.',
				},
				settingsModal: {
					title: 'Hub Settings',
					titleWithName: 'Hub Settings – {name}',
					fields: {
						hubName: 'Hub Name',
						serial: 'Serial',
						project: 'Project',
						location: 'Location',
						state: 'State',
						logOffset: 'Log Offset (hours)',
						alertInterval: 'Alert Interval (min)',
					},
					placeholders: {
						selectProject: 'Select project',
						selectLocation: 'Select location',
						selectState: 'Select state',
					},
					states: {
						active: 'active',
						deactivated: 'deactivated',
					},
					toast: {
						saved: 'Hub updated',
						saveFailed: 'Failed to update hub',
					},
				},
				detail: {
					title: 'Hub',
					activate: 'Activate',
					meta: {
						serial: 'Serial',
						state: 'State',
						alert: 'Alert',
						created: 'Created',
						modified: 'Modified',
						lastLog: 'Last Log',
					},
					modulesTable: {
						headers: {
							state: 'State',
							name: 'Module Name',
							serial: 'Serial',
							created: 'Created',
							modified: 'Modified',
							lastLog: 'Last Log',
							alertInterval: 'Alert Interval',
							visible: 'Visible In Sidebar',
						},
					},
				},
			},
		},
		de: {
			hubs: {
				common: {
					dash: '—',
				},
				header: {
					title: 'Hubs',
					totalModules: '{count} Module',
					searchPlaceholder: 'Hubs suchen',
					searchAria: 'Hubs suchen',
					sortAria: 'Hubs sortieren',
				},
				sort: {
					lastLog_desc: 'Letzter Call (neueste)',
					lastLog_asc: 'Letzter Call (älteste)',
					name_asc: 'Hub-Name (A→Z)',
					name_desc: 'Hub-Name (Z→A)',
					projectName_asc: 'Projekt (A→Z)',
					projectName_desc: 'Projekt (Z→A)',
					moduleCount_desc: 'Anzahl Module (hoch→niedrig)',
					moduleCount_asc: 'Anzahl Module (niedrig→hoch)',
					state_asc: 'Status (A→Z)',
				},
				list: {
					noMatch: 'Keine Hubs entsprechen „{search}“.',
					noData: 'Noch keine Hubs verfügbar.',
					modulesLabel: '{count} Module',
					graphsLabel: '{count} Graphen',
					settings: 'Einstellungen',
					project: 'Projekt',
					location: 'Standort',
					lastCall: 'Letzter Call',
					ipAddress: 'IP-Adresse',
					state: 'Status',
					timezone: 'Zeitzone',
					modulesTitle: 'Module',
					graphsTitle: 'Graphen',
				},
				modulesTable: {
					headers: {
						module: 'Modul',
						serial: 'Seriennummer',
						state: 'Status',
						lastLog: 'Letztes Log',
						alertInterval: 'Alert-Intervall',
						visibility: 'Sichtbarkeit',
						id: 'Id',
						actions: 'Aktionen',
					},
					alertIntervalValue: '{value} min',
					hidden: 'Versteckt',
					visible: 'Sichtbar',
					recalc: 'Neu berechnen',
					noModules: 'Keine Module verbunden.',
					toast: {
						recalcFailed: 'Neuberechnung fehlgeschlagen.',
						recalcRequested: 'Neuberechnung angefordert.',
						recalcError: 'Fehler bei der Neuberechnung.',
						alertIntervalUpdated: 'Alert-Intervall aktualisiert.',
						alertIntervalFailed: 'Alert-Intervall konnte nicht aktualisiert werden.',
						visibilityUpdated: 'Sichtbarkeit aktualisiert.',
						visibilityFailed: 'Sichtbarkeit konnte nicht aktualisiert werden.',
						stateUpdated: 'Status aktualisiert.',
						stateFailed: 'Status konnte nicht aktualisiert werden.',
					},
				},
				graphsTable: {
					headers: {
						graph: 'Graph',
						state: 'Status',
						lastLog: 'Letztes Log',
						linkedModule: 'Verknüpftes Modul',
						id: 'Id',
					},
					empty: 'Keine Graphen für diesen Hub.',
				},
				settingsModal: {
					title: 'Hub-Einstellungen',
					titleWithName: 'Hub-Einstellungen – {name}',
					fields: {
						hubName: 'Hub-Name',
						serial: 'Seriennummer',
						project: 'Projekt',
						location: 'Standort',
						state: 'Status',
						logOffset: 'Log-Offset (Stunden)',
						alertInterval: 'Alarm-Intervall (Min.)',
					},
					placeholders: {
						selectProject: 'Projekt auswählen',
						selectLocation: 'Standort auswählen',
						selectState: 'Status auswählen',
					},
					states: {
						active: 'aktiv',
						deactivated: 'deaktiviert',
					},
					toast: {
						saved: 'Hub aktualisiert',
						saveFailed: 'Hub konnte nicht aktualisiert werden',
					},
				},
				detail: {
					title: 'Hub',
					activate: 'Aktivieren',
					meta: {
						serial: 'Seriennummer',
						state: 'Status',
						alert: 'Alarm',
						created: 'Erstellt',
						modified: 'Geändert',
						lastLog: 'Letztes Log',
					},
					modulesTable: {
						headers: {
							state: 'Status',
							name: 'Modulname',
							serial: 'Seriennummer',
							created: 'Erstellt',
							modified: 'Geändert',
							lastLog: 'Letztes Log',
							alertInterval: 'Alarmintervall',
							visible: 'Sichtbar in Sidebar',
						},
					},
				},
			},
		},
	},
}
